@use 'vars';

.iq-request-error {
  display: flex;
  flex-direction: column;
  padding: vars.$padding-small;
  gap: vars.$gap-large;
  width: 100%;

  &__button {
    background-color: vars.$ai-primary !important;
    width: fit-content;

    &:hover {
      background-color: darken(vars.$ai-primary, 10%) !important;
    }
  }
}
